export const START_DOCUMENTATION_MARKDOWN = `
What It Does
------------

A Start Block is always the first block in a flow.

When a flow is live and running automatically, a Start Block is typically connected to a Scenario to initate the flow. A flow could also initiate from a subflow.

When a flow is being tested, a specific test entity (patient/encounter/order) is selected. This restricts the run to just that selected entity.

Examples
--------

-   Fetch encounter from the schedule - aka pull through CalSync

-   Fetch discharged patients

-   Receive a patient to review

-   Get the pending auth for this order

-   Get the details of an open appointment

-   Get the request for a patient to be scheduled

-   Get the list of patients to schedule

-   Ingest fax document

Important Tips
--------------

For the flow to run automatically, it must be connected to a scenario or come from a subflow of a different flow.

Typically, the scenario will be connected to a feed.

Subflows
---------
A flow can declare *inputs* to be provided when the flow is run.
Specify the name of each input, along with a description, within the Start block.
When a Flow block calls this flow as a subflow, it can specify values for each input.
Within this flow, input values can be accessed in scripts or templates under \`inputs\`
(e.g., if an input is named \`message\`, a script block can use \`inputs.message\`).

*last update: June 2025*
`;
